import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react';
import { SalesOrder, SalesOrderMember } from '@/hooks/api/models';

type Props = {
  children: ReactNode;
};

export type SalesOrderContextType = {
  _so_?: SalesOrder;
  set_so_: Dispatch<SetStateAction<SalesOrder | undefined>>;
  meSalesOrderMember?: SalesOrderMember;
  setMeSalesOrderMember: Dispatch<SetStateAction<SalesOrderMember | undefined>>;
};

export const SalesOrderContext = createContext<SalesOrderContextType>({
  _so_: undefined,
  set_so_: () => {},
  meSalesOrderMember: undefined,
  setMeSalesOrderMember: () => {},
});

export const SalesOrderProvider = ({ children }: Props) => {
  const [_so_, set_so_] = useState<SalesOrder>();
  const [salesOrder, setSalesOrder] = useState<SalesOrder>();
  const [meSalesOrderMember, setMeSalesOrderMember] = useState<SalesOrderMember>();

  return (
    <SalesOrderContext.Provider value={{ _so_, set_so_, meSalesOrderMember, setMeSalesOrderMember }}>
      {children}
    </SalesOrderContext.Provider>
  );
};

export const useCurrentSalesOrder = () => {
  return useContext(SalesOrderContext);
};
